import React from 'react'
import _ from 'lodash'

// import ReadIcon from '@material-ui/icons/RemoveRedEye'
// import WriteIcon from '@material-ui/icons/Edit'
// import AdminIcon from '@material-ui/icons/People'


export const PermisoField = ({ source, record }) => {
    // const hasRead = record[source].includes('read');
    // const hasWrite = record[source].includes('write');
    // const hasAdmin = record[source].includes('admin_users');
    //
    // return (
    //     <div>
    //         {hasRead
    //             ? <ReadIcon style={{ margin: '5px', color: '#33C2D5' }}/>
    //             : <ReadIcon style={{ margin: '5px', color: 'lightgray' }}/>
    //         }
    //         {hasWrite
    //             ? <WriteIcon style={{ margin: '5px', color: '#33C2D5' }}/>
    //             : <WriteIcon style={{ margin: '5px', color: 'lightgray' }}/>
    //         }
    //         {hasAdmin
    //             ? <AdminIcon style={{ margin: '5px', color: '#33C2D5' }}/>
    //             : <AdminIcon style={{ margin: '5px', color: 'lightgray' }}/>
    //         }
    //     </div>
    // )

    const choices = {
        read: 'Ver',
        edit: 'Editar',
        // admin_users: 'Administrar Usuarios'
    }

    return (
        <div>
            {_.map(record[source], item => choices[item]).join(", ")}
        </div>
    )
}
PermisoField.defaultProps = { addLabel: true };
